import { BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";

export const Instructor = () => (
    <section id="mentor" className="scroll-mt-20 bg-white py-20 lg:py-28" data-testid="instructor-section">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:px-8">
            <Reveal>
                <div className="relative mx-auto max-w-md">
                    <div className="absolute -inset-3 rounded-[2rem] border border-[#DDB56C]/40" />
                    <div className="relative overflow-hidden rounded-[1.75rem] shadow-[0_24px_64px_rgba(7,27,55,0.2)]">
                        <img src="/assets/portrait-cici.webp" alt="Priscillia Ester, S.T., M.M. — Praktisi Properti" loading="lazy"
                            className="aspect-[5/6] w-full object-cover object-top" data-testid="instructor-portrait" />
                    </div>
                    <div className="absolute -bottom-5 left-1/2 w-[88%] -translate-x-1/2 rounded-2xl border border-[#DDB56C]/40 bg-[#071B37] px-6 py-4 text-center shadow-[0_16px_40px_rgba(7,27,55,0.35)]">
                        <p className="font-accent text-base font-semibold text-white sm:text-lg" data-testid="instructor-name-card">Priscillia Ester, S.T., M.M.</p>
                        <p className="mt-0.5 text-xs text-[#DDB56C]">CEO of Spark Residence</p>
                    </div>
                </div>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">Mentor Kelas</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="instructor-heading">
                    Belajar Langsung dari{" "}
                    <span className="font-accent italic text-[#123E65]">Praktisi Properti</span>
                </h2>
                <div className="mt-8">
                    <p className="font-accent text-2xl font-semibold text-[#071B37]" data-testid="instructor-name">PRISCILLIA ESTER, S.T., M.M.</p>
                    <p className="mt-2 flex items-center gap-2 text-sm font-medium text-[#1C2533]/70">
                        <BadgeCheck className="h-4 w-4 text-[#DDB56C]" strokeWidth={1.5} />
                        CEO of Spark Residence, Property Deals, Legal Pro.
                    </p>
                </div>
                <div className="my-7 h-px w-24 bg-[#DDB56C]" />
                <p className="text-base leading-relaxed text-[#1C2533]/75 sm:text-lg">
                    Bersama Priscillia Ester dari Cici Developer, kelas ini menghadirkan pembahasan KPR dari sudut pandang praktisi properti, agar peserta dapat memahami pertimbangan yang relevan sebelum maupun selama menjalani pembiayaan rumah.
                </p>
            </Reveal>
        </div>
    </section>
);
